import * as React from 'react'
import {FC} from 'react'
import {observer} from 'mobx-react'
import cn from 'classnames'
import {PaymentMethod} from '@raisenow/epik'
import {useStores} from '../../../../lib/MobXProvider'
import {WidgetApi} from '../../../../lib/WidgetApi'
import {InfoToggle} from '../../../ui/InfoToggle'

///////////////////////////////////////////////////////////////////////////////

export type PaymentMethodInfoProps = {
  paymentMethod: PaymentMethod
}
///////////////////////////////////////////////////////////////////////////////

export const PaymentMethodInfo: FC<PaymentMethodInfoProps> = observer(
  (props) => {
    const {api} = useStores<{api: WidgetApi}>()
    const {paymentMethod} = props

    const textHTML = api.trans(
      `payment_method_info.${paymentMethod}.text_html`,
      {defaultValue: null},
    )

    const infoToggleTitle = api.trans(`info_toggle.${paymentMethod}.title`, {
      defaultValue: null,
    })
    const infoToggleTextHTML = api.trans(
      `info_toggle.${paymentMethod}.text_html`,
      {defaultValue: null},
    )

    return (
      <div className="payment-method-info">
        <div className="main">
          <div
            className="text"
            aria-live="polite"
            dangerouslySetInnerHTML={{__html: textHTML}}
          />
          <div
            className={cn('image', 'payment-method-bg-image-' + paymentMethod)}
          />
        </div>

        <InfoToggle
          idKey={'info-toggle-' + paymentMethod}
          className={cn('info-toggle-pm', 'info-toggle-' + paymentMethod)}
          title={infoToggleTitle}
          textHTML={infoToggleTextHTML}
        />
      </div>
    )
  },
)
